import(/* webpackMode: "eager", webpackExports: ["HeroClouds","RoadmapClouds"] */ "/vercel/path0/app/ui/Clouds.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/sections/coin-token/CoinTokenSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/sections/featured-in/FeaturedInSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/sections/find-your-way/FindYourWaySection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/ui/sections/hero/CryptoWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/sections/hero/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/sections/next-gen/NextGenSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/sections/roadmap/RoadMapSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/ui/sections/tokenomics/TokenomicsSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
